import { Head } from '@inertiajs/react'

import { PublicProfileSettings } from '@/components/organizations/public-profile-settings'
import { DashboardShell } from '@/layouts/dashboard-shell'
import type { OrganizationsPublicProfilesShow } from '@/types'

export default function OrganizationPublicProfilesShow({
  organization,
  repositories,
  publicProfileRepositories,
  organizationOwner,
  publicChangelogMutationsEnabled,
}: OrganizationsPublicProfilesShow) {
  return (
    <>
      <Head title={`${organization.name} — Public Profile`} />
      <DashboardShell organization={organization} repositories={repositories} title="Public Profile">
        <div className="flex justify-center py-8 md:py-16">
          <PublicProfileSettings
            organizationId={organization.id}
            repositories={publicProfileRepositories}
            organizationOwner={organizationOwner}
            mutationsEnabled={publicChangelogMutationsEnabled}
          />
        </div>
      </DashboardShell>
    </>
  )
}
